<template>
  <div>
    <div class="white-section">
      <b-form @submit.prevent class="mt-0">
        <b-row>
          <b-col md="4">
            <b-form-group
                :label="$t('section.sectionTitle')"
                label-for="section-title"
                :invalid-feedback="
            invalidFeedbackTitle
              ? $t(`validation.${invalidFeedbackTitle}`, {
                  field: $t('section.sectionTitle'),
                })
              : ''
          "
                :state="$v.title.$dirty ? !$v.title.$invalid : null"
            >
              <b-form-input autofocus
                  id="section-title"
                  placeholder="عنوان بخش جدید را وارد کنید"
                  :state="$v.title.$dirty ?  !$v.title.$invalid : null"
                  v-model="title"
                  v-on:keyup.enter="onEnter"

              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>

    <div class="white-section mt-2">
      <b-row>
        <div class="col-12 text-right">
          <b-button
              size=""
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="info"
              class=""
              @click="addSection"
          >
            {{ $t("general.submit") }}
          </b-button>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {required} from "vuelidate/lib/validators";
import Ripple from "vue-ripple-directive";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormSelect,
  BFormInvalidFeedback, BBreadcrumb,
} from "bootstrap-vue";

export default {
  mounted() {
  },
  created() {
    this.pushBreadcrumb({text: 'addSection', to:{name:'addSection' }, translate:true})
    this.setCurrentBreadcrumb([{text: 'addSection', to:{name:'addSection' }, translate:true}])
  },
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BFormInvalidFeedback,
    BBreadcrumb,
  },
  data() {
    return {
      items: [
        {
          text: this.$t('section.sections'),
          to: {name : 'manageSection'}
        },
        {
          text: this.$t('section.addSection'),
          active: true
        }
      ]
    }
  },
  validations() {
    return {
      title: {
        required,
      },
    };
  },
  computed: {
    invalidFeedbackTitle: {
      set(error) {
      },
      get() {
        let error = "";
        if (!this.$v.title.$dirty) return error;
        if (!this.$v.title.required) error = "required";
        return error;
      },
    },
    ...mapGetters({}),
    title: {
      set(title) {
        this.$store.commit("sections/SET_TITLE", title);
      },
      get() {
        return this.$store.getters["sections/title"];
      },
    },

  },
  methods: {
    onEnter(){
      this.addSection()
    },
    addSection() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

        const payload = {
          title: this.title,
          status: 'active',
        };
        this.$store.commit('SET_IS_LOADING', true)
        this.$store
            .dispatch("sections/addSection", payload)
            .then((response) => {
              this.$store.commit('SET_IS_LOADING', false)
              this.$bvToast.toast(this.$t('toastification.submissionSucceed'), {
                title: this.$t('toastification.success'),
                variant: 'success',
                solid: true,
              });
              this.title = '';
              this.$router.push({name: "manageSection"});
            })
            .catch((error) => {
              let msg = '';
              switch (error.response.status){
                case 422:
                  msg = this.$t('toastification.duplicatedData');
                  break;
                case 404:
                  msg = this.$t('toastification.notFound');
                  break;
              }
              this.$bvToast.toast(msg, {
                 title: this.$t('toastification.error'),
                variant: 'danger',
                solid: true,
              });
              this.$store.commit('SET_IS_LOADING', false)
            });
      }else{
        this.$nextTick(() => {
        const el = document.querySelector(".is-invalid:first-of-type");
        
        el.scrollIntoView({ behavior: 'instant', block: 'center' });
        // el.scrollIntoView();
        return;
        })
      }
    },
  },
};
</script>